import cashBookInstance from '../../cashBook/instance'

const createCategory = (data) => {
	return cashBookInstance.post('/cash-book/categories', data)
}
export default createCategory
